import type { SessionInstance } from "@/sdk/sessions/session";

export function getPreviousTaskFromSession(session: SessionInstance, taskId: string) {
    const tasks = [...session.getAllTasks().values()];
    const indexOfTask = tasks.findLastIndex((task) => task.id === taskId);
    switch (indexOfTask) {
        case -1: // task not yet found (new call), return last in existing tasks
            return tasks.at(-1);
        case 0: // task found at beginning (rehydrated non-callback), there is no previous task
            return;
        default:
            return tasks.at(indexOfTask - 1);
    }
}
